// worker线程消息通道的全局消息回调队列
export const messageCallbackQuene: ((...args: any[]) => void)[] = [];

export function pushMessageCallback(cb: (...args: any[]) => void) {
  messageCallbackQuene.push(cb);
}

export function removeMessageCallback(cb: (...args: any[]) => void) {
  const index = messageCallbackQuene.indexOf(cb);
  if (index > -1) {
    messageCallbackQuene.splice(index, 1);
  }
}
